<template>
    <div ref="info" class="word-info">
        <img :src="infoImg" alt="" @mouseenter="mouseIn" @mouseout="mouseOut">
        <div  v-if="tipStatus.display" :style="{'width': width, 'left': left, 'top': top}" class="amount-info">
            <div v-html="data">
            </div>
        </div>
        <!-- <border-tips v-if="tipStatus.display" msg="報價說明文案報價說明文案報價說明文案。" width="117px"></border-tips> -->
    </div>
</template>
<script>
import borderTips from '@/components/bussiness/widges/tips/borderTips.vue';
export default {
    data () {
        return {
            show: 0,
            infoImg: require('@/assets/img/icon/info_gray.svg'),
            tipStatus: {
                display: false,
            },
        }
    },
    props: {
        data: String,
        width: String,
        left: {
            type: String,
            default: 'unset'
        },
        top: {
            type: String,
            default: 'unset'
        }
    },
    methods: {
        mouseIn: function () {
            this.infoImg = require('@/assets/img/icon/info_blue.svg')
            this.tipStatus.display = true
            this.$refs.info.style.zIndex = 2
        },
        mouseOut: function () {
            this.infoImg = require('@/assets/img/icon/info_gray.svg')
            this.tipStatus.display = false
            this.$refs.info.style.zIndex = 1

        },
    },
    components: {
        borderTips
    }
}
</script>
<style lang="scss"  >
    .word-info{
        position: relative;
        z-index: 3;
        margin-left: 8px;
        .amount-info{
            position: absolute;
            left: 0px;
            box-shadow: 1px 3px 8px 0 rgba(3, 6, 52, 0.08);
            border: solid 1px #3942b5;
            background-color: #ffffff;
            padding: 12px 16px;
            border-radius: 4px;
            box-sizing: border-box;
            text-align: left;
            line-height: 1.5;
            font-size: 14px;
            color: #292625 !important;
            >div{
                // display: flex;
                // align-items: center;
                // justify-content: space-between;
                margin-bottom: 4px;
                .amount{
                    text-align: right;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/tips/wordTipsHover.vue